import ReactApexChart from "react-apexcharts";
import { Card, CardBody, Col, Row } from "reactstrap";
import { CryptoAnnotationsTitle } from "../../../../Constants/Constants";
import { CryptoAnnotationsChart } from "../../../../Data/General/Widgets/Chart";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";

const CryptoAnnotations = () => {
  return (
    <Col xl="6" lg="12" className="xl-50">
      <Card>
        <CommonCardHeader title={CryptoAnnotationsTitle} />
        <CardBody>
          <div className="chart-container">
            <Row>
              <Col xs="12">
                <div id="crypto-annotation">
                  <ReactApexChart options={CryptoAnnotationsChart} series={CryptoAnnotationsChart.series} type="line" height={400} />
                </div>
              </Col>
            </Row>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default CryptoAnnotations;
